import React from 'react';
import { Route } from 'react-router-dom';
import ServiceSettingsPage from '../pages/services/ServiceSettingsPage';
import ProtectedRoute from '../components/global/ProtectedRoute';

const serviceSettingsRoutes = (
    <Route
        path="/services/section"
        element={
            <ProtectedRoute requiredPermission="settings.service.view">
                <ServiceSettingsPage />
            </ProtectedRoute>
        }
    />
);

export default serviceSettingsRoutes;
